"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.len = void 0;
/**
 * Returns the length of the given 2-vector.
 * @param p a 2d vector
 */
function len(p) {
    return Math.sqrt(p[0] * p[0] + p[1] * p[1]);
}
exports.len = len;
//# sourceMappingURL=len.js.map